import api from "@/services/api"

type RetrieveTransactionReceiptQuery = {
  isMerchant: boolean
}
export const retrieveTransactionReceipt = async (
  transactionId: string,
  query?: RetrieveTransactionReceiptQuery
): Promise<{ receipt: string; webReceiptUrl: string }> => {
  const { body } = await api.get<{
    receipt: string
    webReceiptUrl: string
  }>(`/transactions/${transactionId}/receipt/`, {
    query,
  })
  return body
}
